import React from "react";
import VendorHeader from "../../../CustomComponents/Property/VendorHeader/VendorHeader";
import AgentSideBar from "../AgentSideBar/AgentSideBar";
import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { showErrorToast, showSuccessToast } from "../../../assets/toastUtils";
import { useLocation } from "react-router-dom";
import {
  formatIndianCurrency,
  getContentScore,
  textDateFormatter,
} from "../../../utils/utils";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import Loader from "../../../CustomComponents/Loader/Loader";
import AddressAutocomplete from "../../../CustomComponents/CustomGooglePlaceAPi/AddressAutocomplete";
import SeeBookingSlider from "../../../CustomComponents/SeeBookingsSlider/SeeBookingsSlider";
import NoDataFound from "../../../CustomComponents/NoDataFound/NoDataFound";
import AgentHeader from "../AgentHeader/AgentHeader";
import { getDecryptedData } from "../../../utils/crypto";
import MultipleImageUploadComponent from "../../../CustomComponents/ImageUpload/MultipleImageUploadComponent";
import UploadFileComponent from "../../../CustomComponents/ImageUpload/UploadFileComponent";
import ImageEditor from "../../../CustomComponents/BrandAsset/ImageEditor";
import InputField from "../../../CustomComponents/InputField/InputField";

function AgentAccount() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const role = query.get("role");
  const [loader, setLoader] = useState(false);
  const [allBookings, setAllBookings] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadResult, setUploadResult] = useState("");
  const BearerToken = getDecryptedData("userToken");
  const userToken = getDecryptedData("userToken");
  const [editData, setEditData] = useState({
    general_details: false,
    address_details: false,
    business_details: false,
    contact_details: false,
  });

  const handleFileChange = (event, type) => {
    const file = event.target.files[0];
    setSelectedFile(event.target.files[0]);
    handleSubmitCertificate(file, type);
  };

  const slug = window.location.pathname.split("/");
  // console.log(role ,"slug")

  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("Profile");
  useEffect(() => {
    if (role === "bookings") {
      setActiveTab("Bookings");
    } else {
      setActiveTab("Profile");
    }
  }, []);
  const [isSliderVisible, setIsSliderVisible] = useState(false);

  const handleCloseSlider = () => {
    setIsSliderVisible(false);
  };

  const handleChangeClick = async () => {
    setIsSliderVisible(true);
  };
  const [formData, setFormData] = useState({
    company_name: "",
    phone: "",
    email: "",
    country: "",
    state: "",
    city: "",
    address: "",
    agent_category: "",
    company_gst_information: "",
    company_pan_information: "",
    company_tan_information: "",

    contact_person_information: "",
    contact_person_email_information: "",
    contact_person_number_information: "",

    agent_category_discount: "",
    agent_discount_type: "",
    tac: "",
    zipcode: "",
  });

  const [agentDetails, setAgentDetails] = useState(null);
  const [agentUpdateData, setAgentUpdateData] = useState(null);
  const agent_id = agentDetails?.AgentId;

  const account_id = agentDetails?.AccountId;
  const status = agentUpdateData?.data?.status;

  //fetch categories
  const [categoryDetail, setCategoryDetail] = useState(null);
  const [singleBookingData, setSingleBookingData] = useState(null);
  const [error, setError] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // setFormData({ ...formData, [name]: value });
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  // console.log("formData", formData);

  const [addressData, setAddressData] = useState({
    country: "",
    state: "",
    city: "",
    address: "",
    latitude: "",
    longitude: "",
    placeId: "",
  });

  const userDetails = JSON?.parse(localStorage?.getItem("userDetails"));
  // console.log(userDetails);

  const [agentAccountDetails, setAgentAccountDetails] = useState({});
  // console.log(agentAccountDetails);

  const fetchAccountDetails = (id) => {
    // setLoader(true);
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        key: "D4X50uU40Vz4pweFLEmsoiJy107iPfTD4ompprop1",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      method: "GET",
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_APP_URL}/api/v1/agents/credit-balance/${id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          setAgentAccountDetails(result.data);
          // setLoader(false);
        } else {
          // setLoader(false);
        }
      })
      .catch((error) => console.error("Error fetching single rate:", error));
  };

  useEffect(() => {
    if (userDetails?.AgentId) {
      fetchAccountDetails(userDetails?.AgentId);
    }
  }, [userDetails?.AgentId]);
  // console.log(userDetails);

  const handleAddressData = (data) => {
    // console.log(data, "data");
    setAddressData(data);
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   // console.log({ ...formData, ...addressData });
  //   const valid = validate();
  //   setTimeout(() => {
  //     setFormErrors({});
  //   }, 1500);
  //   if (!valid) {
  //     showErrorToast("Please fill the above details.");
  //     return;
  //   }

  //   const raw = JSON.stringify({ ...formData, ...addressData });

  //   const requestOptions = {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: raw,
  //     redirect: "follow",
  //   };

  //   fetch(
  //     `${process.env.REACT_APP_APP_URL}/api/agent/update/${agent_id}`,
  //     requestOptions
  //   )
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error("Network response was not ok");
  //       }
  //       return response.json();
  //     })
  //     .then((data) => {
  //       setAgentUpdateData(data);
  //       localStorage.setItem("isVerified", data?.data?.status || "false"); // Ensure proper saving
  //       showSuccessToast("Profile Saved Successfully");
  //       fetchAgentDetails();
  //       // navigate("/");
  //       // window.location.href = "/";
  //     })
  //     .catch((error) =>
  //       console.error(
  //         "There has been a problem with your fetch operation:",
  //         error
  //       )
  //     );
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      showErrorToast("Please fill the above details.");
      return;
    }
    // setFormErrors({});
    // setTimeout(() => setFormErrors({}), 1500);

    const apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/update`;

    const headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${BearerToken}`);
    headers.append("Cookie", process.env.REACT_APP_COOKIE);

    const payload = JSON.stringify({ ...formData, ...addressData });

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: payload,
        redirect: "follow",
      });

      const result = await response.json();
      if (result?.success) {
        showSuccessToast(result.message || "Updated Successfully");
        setAgentUpdateData(result);
        localStorage.setItem("isVerified", result?.data?.status || "false");
        fetchAgentDetails();
        setEditData(false);
        window.location.reload();
      } else {
        showErrorToast(result.message);
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      showErrorToast("An error occurred while updating your profile.");
    }
  };

  const profileFilter = (tab) => {
    setActiveTab(tab);
  };

  const fetchAgentDetails = () => {
    setLoader(true); 
    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/user-profile`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${BearerToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setAgentDetails(data?.data);

        localStorage.setItem("userDetails", JSON.stringify(data?.data));
        localStorage.setItem("role", "agent");
       

        setAddressData({
          country: data?.data?.country || "",
          state: data?.data?.state || "",
          city: data?.data?.city || "",
          address: data?.data?.address || "",
          latitude: data?.data?.latitude || "",
          longitude: data?.data?.longitude || "",
          placeId: data?.data?.placeId || "",
        });

        let additionalDetails;

        if (Array.isArray(data?.data?.additional_details)) {
          additionalDetails = {
            company_gst: data?.data?.additional_details[0]?.company_gst,
            company_pan: data?.data?.additional_details[0]?.company_pan,
            company_tan: data?.data?.additional_details[0]?.company_tan,
            contact_person: data?.data?.additional_details[0]?.contact_person,
            contact_person_email:
              data?.data?.additional_details[0]?.contact_person_email,
            contact_person_number:
              data?.data?.additional_details[0]?.contact_person_number,
          };
        } else {
          additionalDetails = {
            company_gst: data?.data?.additional_details?.company_gst,
            company_pan: data?.data?.additional_details?.company_pan,
            company_tan: data?.data?.additional_details?.company_tan,
            contact_person: data?.data?.additional_details?.contact_person,
            contact_person_email:
              data?.data?.additional_details?.contact_person_email,
            contact_person_number:
              data?.data?.additional_details?.contact_person_number,
          };
        }

        setFormData({
          company_name: data?.data?.name || "",
          name: data?.data?.name,
          phone: data?.data?.phone || "",
          email: data?.data?.email,
          country: data?.data?.country || "",
          state: data?.data?.state || "",
          city: data?.data?.city || "",
          address: data?.data?.address || "",
          agent_category_discount: +data?.data?.agent_category_discount || "",
          agent_discount_type: data?.data?.agent_discount_type || "",
          agent_category: data?.data?.AgentCategoryName || "",

          company_gst_information: additionalDetails?.company_gst || "",
          company_pan_information: additionalDetails?.company_pan || "",
          company_tan_information: additionalDetails?.company_tan || "",

          contact_person_information: additionalDetails?.contact_person || "",
          contact_person_email_information:
            additionalDetails?.contact_person_email || "",
          contact_person_number_information:
            additionalDetails?.contact_person_number || "",
          tac: data?.data.tac || "",
          zipcode: data?.data?.zipcode || "",
        });

        if (data.success) {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching agent details:", error);
      });
   
  };
  // console.log(formData, 'lll');
  useEffect(() => {
    const agentData = localStorage.getItem("role");
    // console.log(agentData);
    if (agentData === "agent") {
      fetchAgentDetails();
      // fetchAgentsBookings();

      // fetchSidebarDetails();
    } else {
      fetchAgentDetails();
      // fetchAgentsBookings();
    }
    // fetchAgentsBookings();
  }, [localStorage.getItem("role")]);

  const fetchCategoryDetail = () => {
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_APP_URL}/api/agents/category-list/${account_id}`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json(); // Assuming the API returns JSON
      })
      .then((result) => {
        setCategoryDetail(result);
      })
      .catch((error) => {
        setError(error);
        console.error(
          "There was an error fetching the category details:",
          error
        );
      });
  };

  const fetchAgentsBookings = () => {
    setLoader(true);
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_APP_URL}/api/v1/agents/bookings`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json(); // Assuming the API returns JSON
      })
      .then((result) => {
        if (result.success) {
          const groupByCategory = result?.data?.data?.reduce(
            (group, booking) => {
              const { tour_start } = booking;
              group[tour_start] = group[tour_start] ?? [];
              group[tour_start].push(booking);
              return group;
            },
            {}
          );
          // setLoader(false);

          setAllBookings(groupByCategory);
        }
        // setLoader(false);
      })
      .catch((error) => {
        // setLoader(false);
        setError(error);
        console.error(
          "There was an error fetching the category details:",
          error
        )
      })
     
  };

  const handleSubmitCertificate = (file, type) => {
    if (!file) {
      alert("Please select a file first!");
      return;
    }

    const formData = new FormData();
    formData.append("pdf", file);
    formData.append("collection", type);

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      body: formData,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_APP_URL}/api/v1/agents/agent-doc-upload/${agent_id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        if (result.success) {
          setUploadResult(result);
          fetchAgentDetails();
          toast.success("File uploaded successfully");
        } else {
          toast.error(
            result.message ? result.message : "Error uploading file."
          );
        }
      })
      .catch((error) => {
        console.error(error);
        setUploadResult("Error uploading file.");
      });
  };

  const panImageData = agentDetails?.imageUrl?.find(
    (image) => image.collection === "PAN"
  );

  const gstImageData = agentDetails?.imageUrl?.find(
    (image) => image.collection === "gst_number"
  );
  // console.log(panImageData);

  const deleteImageHandler = async (mediaId) => {
    // console.log(mediaId);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("key", process.env.REACT_APP_API_KEY);
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );

    const raw = JSON.stringify({ mediaId });

    const requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_APP_URL}/api/v1/agents/delete-image`,
        requestOptions
      );
      const result = await response.json();

      if (result.success) {
        toast.success("Image deleted successfully");
        fetchAgentDetails();
      } else {
        toast.error(result.message ? result.message : "Error deleting image.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleOnClick = () => {
    setEditData(!editData);
  };

  const [formErrors, setFormErrors] = useState({});

  // console.log("formData", formData);

  const validate = () => {
    const errors = {};
    // Add validation logic for each form field
    // if (currentStep === 1) {
    if (!formData.name.trim()) {
      errors.name = "required";
    }
    if (!formData.email.trim()) {
      errors.email = "required";
    }
    if (!formData.phone.trim()) {
      errors.phone = "is required";
    }
    // if (!formData.trim.trim()) {
    //   errors.address = "is required";
    // }
    // } else if (currentStep === 2) {
    if (!formData.company_gst_information) {
      errors.company_gst_information = "required";
    }
    if (!formData.company_pan_information) {
      errors.company_pan_information = "required";
    }
    if (!formData.company_tan_information) {
      errors.company_tan_information = "required";
    }
    if (!formData.zipcode) {
      errors.zipcode = "required";
    }
    // if (!formData.company_tan_information) {
    //   errors.company_tan_information = "required";
    // }
    if (!formData.contact_person_information) {
      errors.contact_person_information = "required";
    }
    if (!formData.contact_person_email_information) {
      errors.contact_person_email_information = "required";
    }
    if (!formData.contact_person_number_information) {
      errors.contact_person_number_information = "required";
    }
    // if (!formData.contact_person_number_information) {
    //   errors.contact_person_number_information = "required";
    // }
    // if (!formData.tan) {
    //   errors.tan = "required";
    // }
    // }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const agent_selected_id = JSON.parse(localStorage.getItem("userDetails"));

  // console.log("setFormErrors", formErrors);

  // let additionalDetails = {};
  //     if (Array.isArray(data?.additionalDetails)) {
  //       additionalDetails = {
  //         company_gst: data?.additionalDetails[0]?.company_gst,
  //         company_pan: data?.additionalDetails[0]?.company_pan,
  //         company_tan: data?.additionalDetails[0]?.company_tan,
  //         contact_person: data?.additionalDetails[0]?.contact_person,
  //         contact_person_email:
  //           data?.additionalDetails[0]?.contact_person_email,
  //         contact_person_number:
  //           data?.additionalDetails[0]?.contact_person_number,
  //       };
  //     } else {
  //       additionalDetails = {
  //         company_gst: data?.additionalDetails?.company_gst,
  //         company_pan: data?.additionalDetails?.company_pan,
  //         company_tan: data?.additionalDetails?.company_tan,
  //         contact_person: data?.additionalDetails?.contact_person,
  //         contact_person_email: data?.additionalDetails?.contact_person_email,
  //         contact_person_number: data?.additionalDetails?.contact_person_number,
  //       };
  //     }

  // console.log("additionalDetails", data);

  // const formData = {
  //   ...data,
  //   company_gst_information: additionalDetails?.company_gst,
  //   company_pan_information: additionalDetails?.company_pan,
  //   contact_person_information: additionalDetails?.contact_person,
  //   contact_person_email_information:
  //     additionalDetails?.contact_person_email,
  // };
  const arrayToCheck = [
    "name",
    "email",
    "phone",
    "city",
    "state",
    "country",
    "address",
    "zipcode",
    "company_gst_information",
    "company_pan_information",
    "contact_person_information",
    "contact_person_email_information",
  ];

  const score = getContentScore({
    formData: formData,
    arrayToCheck,
  });

  return (
    <div id="Listingholidays">
      {/* <PageMetaData
        title="Mountain Mysteries"
        description="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        keywords="hotel management, RevCatalyst, property optimization"
      /> */}
      <div className="sidebar_main_div new_sidebar_main_div">
        <AgentSideBar />

        <div className="agent-info-container">
          <AgentHeader showSelectProperty={true} vendorProperty={false} />
          {loader ? (
                <Loader size="4em" color="#016937" />
              ) : (
          <section
            className="w-full"
            style={{ borderRadius: "10px", marginTop: "10px" }}
          >
            <div id="common_bg m_20">
              {/* <div className="flex justify_content_between">
                <h4 className=" mb-10 ">My Account</h4>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: score > 50 ? "rgba(0, 255, 30, 0.2)" : "rgba(255, 0, 0, 0.2)",
                    padding: "5px",
                    borderRadius: "5px",
                    width: "fit-content",
                    // color: "white",
                  }}
                >
                  Content Score: {score}%
                </div>
              </div> */}
            
                <div>
                  <div className="setting-bg-white-div flex justify_content_between align_items_center flex_wrap">
                    <div>
                      {" "}
                      <h4 className=" ">Settings</h4>
                      <span
                        style={{
                          color: "#888888",
                          // marginTop: "5px",
                          display: "block",
                        }}
                      >
                        Set your account settings down below
                      </span>
                    </div>{" "}
                    {/* {editData.general_details ||
                        editData.address_details ||
                        (editData.business_details && ( */}
                    <div className="flex align_items_center flex_gap_5 align_top">
                      <button
                        className="vendor_common_property"
                        onClick={(e) => {
                          handleSubmit(e);
                          // setTimeout(() => handleSubmit(e), 300);
                        }}
                        type="button"
                      >
                        Save Changes
                      </button>
                    </div>
                    {/* ))} */}
                  </div>
                  <div className="flex-div_profile_Sec">
                    <div className="w-half-div">
                      {" "}
                      <div className=" profile-bg-white-div mt-10">
                        <div className="flex align_items_center flex_gap_10">
                          {" "}
                          <div
                            className="profile_name_div"
                            style={{
                              height: "80px",
                              width: "80px",
                              fontSize: "30px",
                            }}
                          >
                            {formData?.name?.charAt(0)}
                          </div>
                          <div>
                            {" "}
                            <h4> {formData.name}</h4>
                            {/* <div className="flex flex_gap_5 mt-5">
                                    {" "}
                                    <button className="profile_sec_btn">
                                      <svg
                                        width="16"
                                        height="17"
                                        viewBox="0 0 16 17"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <mask
                                          id="mask0_7312_11098"
                                          style={{ maskType: "alpha" }}
                                          maskUnits="userSpaceOnUse"
                                          x="0"
                                          y="0"
                                          width="16"
                                          height="17"
                                        >
                                          <rect
                                            y="0.5"
                                            width="16"
                                            height="16"
                                            fill="#D9D9D9"
                                          />
                                        </mask>
                                        <g mask="url(#mask0_7312_11098)">
                                          <path
                                            d="M4.20517 13.4996C3.86839 13.4996 3.58333 13.383 3.35 13.1496C3.11667 12.9163 3 12.6313 3 12.2945V10.9868C3 10.8449 3.04789 10.7261 3.14367 10.6305C3.23933 10.5347 3.35811 10.4868 3.5 10.4868C3.64189 10.4868 3.76067 10.5347 3.85633 10.6305C3.95211 10.7261 4 10.8449 4 10.9868V12.2945C4 12.3458 4.02139 12.3928 4.06417 12.4355C4.10683 12.4783 4.15383 12.4996 4.20517 12.4996H11.7948C11.8462 12.4996 11.8932 12.4783 11.9358 12.4355C11.9786 12.3928 12 12.3458 12 12.2945V10.9868C12 10.8449 12.0479 10.7261 12.1437 10.6305C12.2393 10.5347 12.3581 10.4868 12.5 10.4868C12.6419 10.4868 12.7607 10.5347 12.8563 10.6305C12.9521 10.7261 13 10.8449 13 10.9868V12.2945C13 12.6313 12.8833 12.9163 12.65 13.1496C12.4167 13.383 12.1316 13.4996 11.7948 13.4996H4.20517ZM7.5 5.42531L6.218 6.70731C6.11878 6.80642 6.00106 6.85537 5.86483 6.85414C5.7285 6.85281 5.60861 6.80042 5.50517 6.69698C5.40861 6.59364 5.35861 6.47659 5.35517 6.34581C5.35172 6.21503 5.40172 6.09792 5.50517 5.99448L7.57817 3.92148C7.64061 3.85903 7.70644 3.81503 7.77567 3.78948C7.84489 3.76381 7.91967 3.75098 8 3.75098C8.08033 3.75098 8.15511 3.76381 8.22433 3.78948C8.29356 3.81503 8.35939 3.85903 8.42183 3.92148L10.4948 5.99448C10.5939 6.09359 10.6429 6.20964 10.6417 6.34264C10.6403 6.47553 10.5914 6.59364 10.4948 6.69698C10.3914 6.80042 10.2726 6.85387 10.1385 6.85731C10.0043 6.86075 9.88544 6.81075 9.782 6.70731L8.5 5.42531V10.5253C8.5 10.6672 8.45211 10.786 8.35633 10.8816C8.26067 10.9774 8.14189 11.0253 8 11.0253C7.85811 11.0253 7.73933 10.9774 7.64367 10.8816C7.54789 10.786 7.5 10.6672 7.5 10.5253V5.42531Z"
                                            fill="#333333"
                                          />
                                        </g>
                                      </svg>
                                      Upload Image
                                    </button>
                                    <button className="profile_sec_btn">
                                      Remove
                                    </button>
                                  </div> */}
                          </div>
                        </div>
                        <div className="profile_sec_link">
                          {/* <h6> {formData.name}</h6> */}
                          <Link to="tel:9816012966">
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_7312_12223"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="18"
                                height="18"
                              >
                                <rect width="18" height="18" fill="#D9D9D9" />
                              </mask>
                              <g mask="url(#mask0_7312_12223)">
                                <path
                                  d="M14.5802 15.375C13.1668 15.375 11.7469 15.0464 10.3204 14.3891C8.894 13.7319 7.58225 12.8048 6.38513 11.6077C5.19288 10.4106 4.26813 9.1 3.61088 7.67588C2.95363 6.25188 2.625 4.83319 2.625 3.41981C2.625 3.19481 2.7 3.00606 2.85 2.85356C3 2.70119 3.1875 2.625 3.4125 2.625H5.85862C6.048 2.625 6.21506 2.68681 6.35981 2.81044C6.50456 2.93394 6.59663 3.08656 6.636 3.26831L7.06594 5.475C7.09569 5.67975 7.08944 5.85569 7.04719 6.00281C7.00481 6.14994 6.92881 6.2735 6.81919 6.3735L5.08706 8.05969C5.36581 8.57019 5.68431 9.05313 6.04256 9.5085C6.40069 9.96375 6.78844 10.3986 7.20581 10.8129C7.61731 11.2246 8.05481 11.6068 8.51831 11.9597C8.98181 12.3126 9.48231 12.6409 10.0198 12.9448L11.7028 11.2472C11.8202 11.1251 11.9623 11.0394 12.1292 10.9903C12.2959 10.9413 12.4693 10.9293 12.6491 10.9543L14.7317 11.3784C14.9211 11.4284 15.0756 11.5251 15.1954 11.6683C15.3151 11.8116 15.375 11.9741 15.375 12.1558V14.5875C15.375 14.8125 15.2988 15 15.1464 15.15C14.9939 15.3 14.8052 15.375 14.5802 15.375Z"
                                  fill="white"
                                />
                              </g>
                            </svg>
                            {formData.phone}
                          </Link>
                          <Link to="mailto:sales@mountainmysteries.com">
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_7312_12217"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="18"
                                height="18"
                              >
                                <rect width="18" height="18" fill="#D9D9D9" />
                              </mask>
                              <g mask="url(#mask0_7312_12217)">
                                <path
                                  d="M3.23081 14.625C2.85194 14.625 2.53125 14.4938 2.26875 14.2313C2.00625 13.9688 1.875 13.6481 1.875 13.2692V4.73081C1.875 4.35194 2.00625 4.03125 2.26875 3.76875C2.53125 3.50625 2.85194 3.375 3.23081 3.375H14.7692C15.1481 3.375 15.4688 3.50625 15.7313 3.76875C15.9938 4.03125 16.125 4.35194 16.125 4.73081V13.2692C16.125 13.6481 15.9938 13.9688 15.7313 14.2313C15.4688 14.4938 15.1481 14.625 14.7692 14.625H3.23081ZM9 9.29419C9.0625 9.29419 9.1245 9.28481 9.186 9.26606C9.24762 9.24731 9.30725 9.22162 9.36487 9.189L14.7289 5.75475C14.8144 5.70187 14.8749 5.63338 14.9106 5.54925C14.9462 5.46513 14.9567 5.37644 14.9423 5.28319C14.9326 5.11006 14.848 4.98144 14.6884 4.89731C14.5289 4.81319 14.3679 4.82063 14.2054 4.91963L9 8.25L3.79463 4.91963C3.63213 4.82063 3.47231 4.81269 3.31519 4.89581C3.15794 4.97906 3.07212 5.10575 3.05775 5.27588C3.04325 5.37688 3.05381 5.47063 3.08944 5.55713C3.12506 5.64375 3.18563 5.70962 3.27113 5.75475L8.63513 9.189C8.69275 9.22162 8.75238 9.24731 8.814 9.26606C8.8755 9.28481 8.9375 9.29419 9 9.29419Z"
                                  fill="white"
                                />
                              </g>
                            </svg>
                            {formData?.email}
                          </Link>
                        </div>
                      </div>
                      <div className="setting-bg-white-div mt-10">
                        <div className="edit-rooms-form-wrapper-container">
                          <h4 className="mb-10">Upload Brand Logo</h4>

                          {/* <MultipleImageUploadComponent
                              modelType="accommodation"
                              modelId={agent_selected_id?.id}
                              upload_collection="photos"
                              urlType="website/supplier/file/fetch"
                              uploadType={"website/supplier/file/upload"}
                              deleteType={"website/supplier/file/delete"}
                              // onFileUpload={handleFileUpload}
                              // setState={setIsPopupVisible}
                              // imageData={imageData}
                              fileTypeDisabled={true}
                            /> */}

                          <MultipleImageUploadComponent
                            modelType={"agents"}
                            modelId={agent_selected_id?.id}
                            urlType={"website/agent/file/fetch"}
                            deleteType={"website/agent/file/delete"}
                            uploadType={"website/agent/file/upload"}
                            file_type_agent={"agent-logo"}
                            tokenType={"agent"}
                            showSingleImage={true}
                          />
                        </div>
                        <div className="edit-rooms-form-wrapper-container  mt-10"></div>
                      </div>
                      <div className="setting-bg-white-div mt-10">
                        <h4>Document Upload</h4>
                        <div className="profile_content Profile">
                          <UploadFileComponent
                            upload_collection="documents"
                            uploadType={"website/agent/file/upload"}
                            fetchType={"website/agent/file/fetch"}
                            deleteType={"website/agent/file/delete"}
                            modelType="agents"
                            modelId={agent_selected_id?.id}
                            fileType="pdf"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="w-half-div ">
                      <div className="setting-bg-white-div mt-10">
                        {editData["general_details"] === true ? (
                          <div>
                            <div className="flex align_items_center justify_content_between">
                              <h4>1. General Details</h4>
                              <div className="flex align_items_center flex_gap_5">
                                <button
                                  type="button"
                                  onClick={() =>
                                    setEditData((prev) => ({
                                      ...prev,
                                      general_details: false,
                                    }))
                                  }
                                >
                                  <svg
                                    width="13"
                                    height="13"
                                    viewBox="0 0 14 13"
                                    style={{ margin: "5px" }}
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M1 12.5L13 0.5"
                                      stroke="#AAAAAA"
                                      strokeWidth="1.2"
                                    />
                                    <path
                                      d="M13 12.5L1 0.5"
                                      stroke="#AAAAAA"
                                      strokeWidth="1.2"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>{" "}
                            <div className="profile_content Profile mt-10">
                              <div>
                                {currentStep === 1 && (
                                  <div>
                                    <div>
                                      <InputField
                                        label="Name"
                                        name="name"
                                        type="text"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        placeholder="Name"
                                        error={formErrors.name}
                                      />
                                    </div>

                                    <div className="input-flex mt-10">
                                      <div>
                                        <InputField
                                          label="Phone"
                                          name="phone"
                                          type="number"
                                          value={formData.phone}
                                          onChange={handleInputChange}
                                          placeholder="Phone"
                                          error={formErrors.phone}
                                        />
                                      </div>
                                      <div>
                                        <InputField
                                          label="Email"
                                          name="email"
                                          type="email"
                                          value={formData.email}
                                          onChange={handleInputChange}
                                          placeholder="Email"
                                          error={formErrors.email}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div className="flex align_items_center justify_content_between">
                              <h4>1. General Details</h4>
                              <button
                                onClick={() =>
                                  setEditData((prev) => ({
                                    ...prev,
                                    general_details: true,
                                  }))
                                }
                                type="button"
                              >
                                <svg
                                  width="22"
                                  height="22"
                                  viewBox="0 0 26 27"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <mask
                                    id="mask0_4568_4221"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="26"
                                    height="27"
                                  >
                                    <rect
                                      y="0.5"
                                      width="26"
                                      height="26"
                                      fill="#009A50"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_4568_4221)">
                                    <path
                                      d="M5.41667 21.0833H6.96042L17.55 10.4938L16.0063 8.95L5.41667 19.5396V21.0833ZM3.25 23.25V18.6458L17.55 4.37292C17.7667 4.17431 18.0059 4.02083 18.2677 3.9125C18.5295 3.80417 18.8049 3.75 19.0938 3.75C19.3826 3.75 19.6625 3.80417 19.9333 3.9125C20.2042 4.02083 20.4389 4.18333 20.6375 4.4L22.1271 5.91667C22.3438 6.11528 22.5017 6.35 22.601 6.62083C22.7003 6.89167 22.75 7.1625 22.75 7.43333C22.75 7.72222 22.7003 7.99757 22.601 8.25938C22.5017 8.52118 22.3438 8.76042 22.1271 8.97708L7.85417 23.25H3.25ZM16.7646 9.73542L16.0063 8.95L17.55 10.4938L16.7646 9.73542Z"
                                      fill="#009A50"
                                    />
                                  </g>
                                </svg>
                              </button>
                            </div>
                            <div className="profile_content Profile">
                              <div>
                                <div className="gap_items">
                                  <div className="mt-10 w-half">
                                    <p className="py-5">Name</p>
                                    <p className="py-5">Email</p>
                                    <p className="py-5">Phone</p>
                                  </div>
                                  <div className="mt-10 w-half overflow-hidden">
                                    <p className="py-5 text-end">
                                      {formData?.company_name}
                                    </p>
                                    <p className="py-5 text-end">
                                      {formData.email}
                                    </p>
                                    <p className="py-5 text-end">
                                      {formData.phone}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="setting_line"></div>

                        {editData["address_details"] === true ? (
                          <div className="">
                            <div className="flex align_items_center justify_content_between">
                              <h4>2. Address</h4>
                              <div>
                                <button
                                  // className="no_logout_btn"
                                  type="button"
                                  onClick={() =>
                                    setEditData((prev) => ({
                                      ...prev,
                                      address_details: false,
                                    }))
                                  }
                                >
                                  <svg
                                    width="13"
                                    height="13"
                                    viewBox="0 0 14 13"
                                    style={{ margin: "5px" }}
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M1 12.5L13 0.5"
                                      stroke="#AAAAAA"
                                      strokeWidth="1.2"
                                    />
                                    <path
                                      d="M13 12.5L1 0.5"
                                      stroke="#AAAAAA"
                                      strokeWidth="1.2"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>
                            <div className="profile_content Profile mt-10">
                              <div>
                                <label
                                  htmlFor="address"
                                  className="address_label"
                                >
                                  Address
                                </label>
                                <AddressAutocomplete
                                  formdata={addressData}
                                  style={
                                    formErrors.address && {
                                      backgroundColor: "#ff000040",
                                      border: "1px solid red",
                                    }
                                  }
                                  onAddressChange={handleAddressData}
                                />
                              </div>
                              <div className="mt-10">
                                <InputField
                                  label="Zip Code"
                                  name="zipcode"
                                  type="number"
                                  value={formData.zipcode}
                                  onChange={handleInputChange}
                                  placeholder="Zip Code"
                                  error={formErrors.zipcode}
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div className="flex align_items_center justify_content_between">
                              {" "}
                              <h4> 2. Address</h4>
                              <button
                                // className="vendor_common_property"
                                onClick={() =>
                                  setEditData((prev) => ({
                                    ...prev,
                                    address_details: true,
                                  }))
                                }
                                type="button"
                              >
                                <svg
                                  width="22"
                                  height="22"
                                  viewBox="0 0 26 27"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <mask
                                    id="mask0_4568_4221"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="26"
                                    height="27"
                                  >
                                    <rect
                                      y="0.5"
                                      width="26"
                                      height="26"
                                      fill="#009A50"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_4568_4221)">
                                    <path
                                      d="M5.41667 21.0833H6.96042L17.55 10.4938L16.0063 8.95L5.41667 19.5396V21.0833ZM3.25 23.25V18.6458L17.55 4.37292C17.7667 4.17431 18.0059 4.02083 18.2677 3.9125C18.5295 3.80417 18.8049 3.75 19.0938 3.75C19.3826 3.75 19.6625 3.80417 19.9333 3.9125C20.2042 4.02083 20.4389 4.18333 20.6375 4.4L22.1271 5.91667C22.3438 6.11528 22.5017 6.35 22.601 6.62083C22.7003 6.89167 22.75 7.1625 22.75 7.43333C22.75 7.72222 22.7003 7.99757 22.601 8.25938C22.5017 8.52118 22.3438 8.76042 22.1271 8.97708L7.85417 23.25H3.25ZM16.7646 9.73542L16.0063 8.95L17.55 10.4938L16.7646 9.73542Z"
                                      fill="#009A50"
                                    />
                                  </g>
                                </svg>
                              </button>
                            </div>
                            <div className="profile_content Profile">
                              <div>
                                <div className="gap_items">
                                  <div className="mt-10 w-half">
                                    <p className="py-5">Country</p>
                                    <p className="py-5">City</p>
                                    <p className="py-5">State</p>
                                    <p className="py-5">Address</p>
                                    <p className="py-5">Zip Code</p>
                                  </div>
                                  <div className="mt-10 w-half">
                                    <p className="py-5 text-end">
                                      {addressData?.country}
                                    </p>
                                    <p className="py-5 text-end">
                                      {addressData?.city}
                                    </p>
                                    <p className="py-5 text-end">
                                      {addressData?.state}
                                    </p>
                                    <p className="py-5 text-end">
                                      {addressData?.address}
                                    </p>
                                    <p className="py-5 text-end">
                                      {formData?.zipcode
                                        ? formData?.zipcode
                                        : "NA"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="setting_line"></div>

                        {editData["contact_details"] === true ? (
                          <div className="">
                            <div className="flex align_items_center justify_content_between">
                              <h4>3. Contact Person</h4>
                              <div>
                                <button
                                  // className="no_logout_btn"
                                  type="button"
                                  onClick={() =>
                                    setEditData((prev) => ({
                                      ...prev,
                                      contact_details: false,
                                    }))
                                  }
                                >
                                  <svg
                                    width="13"
                                    height="13"
                                    viewBox="0 0 14 13"
                                    style={{ margin: "5px" }}
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M1 12.5L13 0.5"
                                      stroke="#AAAAAA"
                                      strokeWidth="1.2"
                                    />
                                    <path
                                      d="M13 12.5L1 0.5"
                                      stroke="#AAAAAA"
                                      strokeWidth="1.2"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>
                            <div className="mt-10">
                              <div>
                                <InputField
                                  label="Contact Person Name"
                                  name="contact_person_information"
                                  type="text"
                                  value={formData.contact_person_information}
                                  onChange={handleInputChange}
                                  placeholder=" Person Name"
                                  error={formErrors.contact_person_information}
                                />
                              </div>
                            </div>
                            <div className="input-flex mt-10">
                              <div>
                                <InputField
                                  label=" Contact Person Email"
                                  name="contact_person_email_information"
                                  type="email"
                                  value={
                                    formData.contact_person_email_information
                                  }
                                  onChange={handleInputChange}
                                  placeholder=" Contact Person Email"
                                  error={
                                    formErrors.contact_person_email_information
                                  }
                                />
                              </div>
                              <div>
                                <InputField
                                  label=" Contact Person Number"
                                  name="contact_person_number_information"
                                  type="number"
                                  value={
                                    formData.contact_person_number_information
                                  }
                                  onChange={handleInputChange}
                                  placeholder="  Contact Person Number"
                                  error={
                                    formErrors.contact_person_number_information
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="overflow-hidden">
                            <div className="flex align_items_center justify_content_between">
                              <h4> 3. Contact Person</h4>
                              <button
                                onClick={() =>
                                  setEditData((prev) => ({
                                    ...prev,
                                    contact_details: true,
                                  }))
                                }
                                type="button"
                              >
                                <svg
                                  width="22"
                                  height="22"
                                  viewBox="0 0 26 27"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <mask
                                    id="mask0_4568_4221"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="26"
                                    height="27"
                                  >
                                    <rect
                                      y="0.5"
                                      width="26"
                                      height="26"
                                      fill="#009A50"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_4568_4221)">
                                    <path
                                      d="M5.41667 21.0833H6.96042L17.55 10.4938L16.0063 8.95L5.41667 19.5396V21.0833ZM3.25 23.25V18.6458L17.55 4.37292C17.7667 4.17431 18.0059 4.02083 18.2677 3.9125C18.5295 3.80417 18.8049 3.75 19.0938 3.75C19.3826 3.75 19.6625 3.80417 19.9333 3.9125C20.2042 4.02083 20.4389 4.18333 20.6375 4.4L22.1271 5.91667C22.3438 6.11528 22.5017 6.35 22.601 6.62083C22.7003 6.89167 22.75 7.1625 22.75 7.43333C22.75 7.72222 22.7003 7.99757 22.601 8.25938C22.5017 8.52118 22.3438 8.76042 22.1271 8.97708L7.85417 23.25H3.25ZM16.7646 9.73542L16.0063 8.95L17.55 10.4938L16.7646 9.73542Z"
                                      fill="#009A50"
                                    />
                                  </g>
                                </svg>
                              </button>
                            </div>
                            <div className="gap_items">
                              {" "}
                              <div className="mt-10 w-half">
                                <p className="py-5">Contact Person</p>
                                <p className="py-5">Contact Person Email</p>
                                <p className="py-5">Contact Person Number</p>
                              </div>
                              <div className="mt-10 w-half">
                                <p className="py-5 text-end">
                                  {formData?.contact_person_information
                                    ? formData?.contact_person_information
                                    : "-"}{" "}
                                </p>
                                <p className="py-5 text-end">
                                  {formData?.contact_person_email_information
                                    ? formData?.contact_person_email_information
                                    : "-"}{" "}
                                </p>
                                <p className="py-5 text-end">
                                  {formData?.contact_person_number_information
                                    ? formData?.contact_person_number_information
                                    : "-"}{" "}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="setting_line"></div>

                        {editData["business_details"] === true ? (
                          <div className="">
                            <div className="flex align_items_center justify_content_between">
                              <h4>4. Business Information</h4>
                              <button
                                // className="no_logout_btn"
                                type="button"
                                onClick={() =>
                                  setEditData((prev) => ({
                                    ...prev,
                                    business_details: false,
                                  }))
                                }
                              >
                                <svg
                                  width="13"
                                  height="13"
                                  viewBox="0 0 14 13"
                                  style={{ margin: "5px" }}
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M1 12.5L13 0.5"
                                    stroke="#AAAAAA"
                                    strokeWidth="1.2"
                                  />
                                  <path
                                    d="M13 12.5L1 0.5"
                                    stroke="#AAAAAA"
                                    strokeWidth="1.2"
                                  />
                                </svg>
                              </button>
                            </div>
                            <div className="profile_content Profile mt-10">
                              <div>
                                <div className="input-flex">
                                  <div className="text-capitalize">
                                    <InputField
                                      label=" GST No."
                                      name="company_gst_information"
                                      type="text"
                                      value={formData.company_gst_information}
                                      onChange={handleInputChange}
                                      placeholder=" GST No."
                                      error={formErrors.company_gst_information}
                                    />
                                  </div>
                                  <div>
                                    <InputField
                                      label=" PAN No."
                                      name="company_pan_information"
                                      type="text"
                                      value={formData.company_pan_information}
                                      onChange={handleInputChange}
                                      placeholder=" PAN No."
                                      error={formErrors.company_pan_information}
                                    />
                                  </div>
                                </div>
                                <div className="input-flex mt-10">
                                  <div>
                                    <InputField
                                      label="  TAN Number"
                                      name="company_tan_information"
                                      type="text"
                                      value={formData.company_tan_information}
                                      onChange={handleInputChange}
                                      placeholder="  TAN Number"
                                      error={formErrors.company_tan_information}
                                    />
                                  </div>
                                  {/* <div>
                                    <label htmlFor="discount">TAC %</label>
                                    <input
                                      className="w-full"
                                      onChange={handleInputChange}
                                      placeholder="TAC %"
                                      name="tac"
                                      value={formData.tac}
                                      disabled
                                    />
                                  </div> */}
                                </div>

                                {/* <div className="input-flex">
                                <div>
                                  <label htmlFor="discount">
                                    Agent Category Discount
                                  </label>
                                  <input
                                    className="w-full"
                                    disabled={true}
                                    onChange={handleInputChange}
                                    // type="number"
                                    placeholder="Agent Category Discount"
                                    name="Agent Category Discount"
                                    value={`${
                                      formData.agent_category_discount
                                    } ${
                                      formData.agent_discount_type ===
                                        "percentage" && "%"
                                    }`}
                                  />
                                </div>
                                <div>
                                  <label htmlFor="agent">
                                    Agent Category Name
                                  </label>
                                  <input
                                    className="w-full"
                                    disabled={true}
                                    onChange={handleInputChange}
                                    type="text"
                                    placeholder="Agent Category"
                                    name="agent_category"
                                    value={formData.agent_category}
                                  />
                                </div>
                              </div> */}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="">
                            <div className="flex align_items_center justify_content_between">
                              <h4>4. Business Information</h4>
                              <div>
                                {" "}
                                <button
                                  onClick={() =>
                                    setEditData((prev) => ({
                                      ...prev,
                                      business_details: true,
                                    }))
                                  }
                                  type="button"
                                >
                                  <svg
                                    width="22"
                                    height="22"
                                    viewBox="0 0 26 27"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <mask
                                      id="mask0_4568_4221"
                                      style={{ maskType: "alpha" }}
                                      maskUnits="userSpaceOnUse"
                                      x="0"
                                      y="0"
                                      width="26"
                                      height="27"
                                    >
                                      <rect
                                        y="0.5"
                                        width="26"
                                        height="26"
                                        fill="#009A50"
                                      />
                                    </mask>
                                    <g mask="url(#mask0_4568_4221)">
                                      <path
                                        d="M5.41667 21.0833H6.96042L17.55 10.4938L16.0063 8.95L5.41667 19.5396V21.0833ZM3.25 23.25V18.6458L17.55 4.37292C17.7667 4.17431 18.0059 4.02083 18.2677 3.9125C18.5295 3.80417 18.8049 3.75 19.0938 3.75C19.3826 3.75 19.6625 3.80417 19.9333 3.9125C20.2042 4.02083 20.4389 4.18333 20.6375 4.4L22.1271 5.91667C22.3438 6.11528 22.5017 6.35 22.601 6.62083C22.7003 6.89167 22.75 7.1625 22.75 7.43333C22.75 7.72222 22.7003 7.99757 22.601 8.25938C22.5017 8.52118 22.3438 8.76042 22.1271 8.97708L7.85417 23.25H3.25ZM16.7646 9.73542L16.0063 8.95L17.55 10.4938L16.7646 9.73542Z"
                                        fill="#009A50"
                                      />
                                    </g>
                                  </svg>
                                </button>
                              </div>
                            </div>
                            <div className="profile_content Profile">
                              <div>
                                <div className="gap_items">
                                  <div className="mt-10 w-half">
                                    <p className="py-5">GST No.</p>
                                    <p className="py-5">PAN No.</p>
                                    {/* <p className="py-5">TAN Number</p> */}
                                    <p className="py-5">TAN No.</p>

                                    {/* <p className="py-5">TAC %</p> */}

                                    {/* 
          <p className="py-5">Agent Category Name</p>
          <p className="py-5">
            Agent Category Discount
          </p> */}
                                  </div>
                                  <div className="mt-10 w-half">
                                    <p className="py-5 text-end">
                                      {formData?.company_gst_information
                                        ? formData?.company_gst_information
                                        : "-"}
                                    </p>
                                    <p className="py-5 text-end">
                                      {formData?.company_pan_information
                                        ? formData?.company_pan_information
                                        : "-"}{" "}
                                    </p>
                                    <p className="py-5 text-end">
                                      {formData?.company_tan_information
                                        ? formData?.company_tan_information
                                        : "-"}{" "}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              
            </div>
          </section>)}
        </div>
      </div>
    </div>
  );
}

export default AgentAccount;

{
  /* <div className="common_background mt-10">
                          <h4>Documentation</h4>
                          <div className="profile_content Profile">
                            <div >
                              <div className="input-flex">
                                <div className="edit-rooms-div-wrapper-container  mt-10">
                                  <label htmlFor="discount mb-10">
                                    Gst Certificate
                                  </label>

                                  {gstImageData?.url ? (
                                    <>
                                      <div className="featureImages_uploadFile_img_container">
                                        <img src={gstImageData.url} alt="pan" />
                                        <div
                                          onClick={() =>
                                            deleteImageHandler(gstImageData?.id)
                                          }
                                          className="featureImages_uploadFile_delete"
                                        >
                                          <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 14 13"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M1 12.5L13 0.5"
                                              stroke="#AAAAAA"
                                              strokeWidth="1.2"
                                            />
                                            <path
                                              d="M13 12.5L1 0.5"
                                              stroke="#AAAAAA"
                                              strokeWidth="1.2"
                                            />
                                          </svg>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div style={{ position: "relative" }}>
                                        <div className="featureImages_uplaodFile_displaytext_container">
                                          <p className="featured_image_text">
                                            Add Files
                                          </p>
                                          <p className="featured_image_text_dragdrop">
                                            or drop JPG, PNG images here
                                          </p>
                                          <input
                                            accept="image/*"
                                            type="file"
                                            id="select-image"
                                            className="featureImages_upload_file_input"
                                            onChange={(e) =>
                                              handleFileChange(e, "gst_number")
                                            }
                                          />
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>

                                <div className="edit-rooms-div-wrapper-container  mt-10">
                                  <label htmlFor="discount mb-10">
                                    PAN Certificate
                                  </label>
                                  {panImageData?.url ? (
                                    <>
                                      <div className="featureImages_uploadFile_img_container">
                                        <img src={panImageData.url} alt="pan" />
                                        <button
                                          type="button"
                                          onClick={() =>
                                            deleteImageHandler(panImageData?.id)
                                          }
                                          className="featureImages_uploadFile_delete"
                                        >
                                          <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 14 13"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M1 12.5L13 0.5"
                                              stroke="#AAAAAA"
                                              strokeWidth="1.2"
                                            />
                                            <path
                                              d="M13 12.5L1 0.5"
                                              stroke="#AAAAAA"
                                              strokeWidth="1.2"
                                            />
                                          </svg>
                                        </button>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div style={{ position: "relative" }}>
                                        <div className="featureImages_uplaodFile_displaytext_container">
                                          <p className="featured_image_text">
                                            Add Files
                                          </p>
                                          <p className="featured_image_text_dragdrop">
                                            or drop JPG, PNG images here
                                          </p>
                                          <div>
                                            <input
                                              accept="image/*"
                                              type="file"
                                              id="select-image"
                                              className="featureImages_upload_file_input"
                                              onChange={(e) =>
                                                handleFileChange(e, "PAN")
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */
}
